"use client";
import { DirectusImage } from "@/components/DirectusImage";
import InfiniteMoving from "@/components/ui/infinite-moving";
import Title from "@/components/ui/title";
import { cn, getDecimals } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { useMemo } from "react";
import CountUp from "react-countup";

export default function CorporateHonor(props: {
  data?: {
    honors?: {
      name?: string;
    }[];
    data?: {
      value?: number;
      unit?: string;
      text?: string;
    }
    // slogan?: {
    //   icon?: string;
    //   text?: string;
    // }
    logos?: {
      logo?: string;
    }[];
  }
}) {
  const t = useScopedI18n("南芯简介");

  const dataGroups = useMemo(() => {
    const arr: string[][] = [[]];
    let i = 0;
    props.data?.honors?.forEach((el) => {
      if (el.name) {
        if (i <= 4) {
          arr[arr.length - 1].push(el.name);
          i++;
        } else {
          arr.push([el.name]);
          i = 1;
        }
      }
    });
    return arr;
  }, [props.data]);
  return (
    <div className="w-full">
      <Title title={t("企业荣誉资质")} underline={false} />
      {dataGroups.map((el, index) => (
        <InfiniteMoving
          key={index}
          className={cn(
            "w-full mt-3 md:mt-12",
            {
              "mt-7": index === 0,
            }
          )}
          speed="slow"
          gap="xl"
          direction={index % 2 === 0 ? "left" : "right"}
          disabled={el.length < 3}
        >
          {el.map((item, i) => (
            <div
              key={`honor_${index}_${i}`}
              className="flex items-center px-4 py-2.5 text-xs text-center bg-[#F4F6FC] md:px-10 md:py-5 md:text-base"
            >
              <img className="mr-1.5 w-4 md:mr-2.5 md:w-7" src="/icon/reward.svg" alt="Icon Reward" />
              {item}
            </div>
          ))}
        </InfiniteMoving>
      ))}
      <div className="flex flex-col mt-11 gap-y-6 md:flex-row md:justify-between md:items-center md:gap-x-6 md:mt-16">
        {!!props.data?.data && (
          <div className="max-md:text-center">
            {/* <span className="text-zinc-600 text-2xl font-bold leading-normal md:text-4xl">
              <CountUp
                start={0}
                end={props.data.data.value || 0}
                decimals={getDecimals(props.data.data.value || 0)}
                separator={""}
                enableScrollSpy
                scrollSpyOnce
              />
              {props.data.data.unit}
            </span> */}
            <p className="text-zinc-700 text-sm md:text-2xl">{props.data.data.text}</p>
          </div>
        )}
        {/* {!!props.data?.slogan && (
          <div className="flex items-center">
            {props.data.slogan.icon && (
              <DirectusImage
                id={props.data.slogan.icon}
                alt=""
                className="mr-2"
                width={42}
                height={42}
              />
            )}
            <span className="text-zinc-600 text-xl font-bold">
              {props.data.slogan.text}
            </span>
          </div>
        )} */}
        <div className="w-full grid grid-cols-2 gap-x-[24vw] gap-y-6 md:grid-cols-3 lg:grid-cols-4 md:gap-x-16 md:max-w-[600px] lg:max-w-[800px]">
          {props.data?.logos?.map((el, index) => {
            if (el.logo) {
              return (
                <div key={index} className="relative h-6 md:h-8 md:text-right">
                  <DirectusImage
                    id={el.logo}
                    alt={`Customer Logo ${index + 1}`}
                    fill
                    className="object-contain object-left md:object-right"
                  />
                </div>
              )
            }
            return null;
          })}
        </div>
      </div>
    </div>
  )
}
